<ambita-cadastre-report-single-heritages>
  <div class="ambita-cadastre-report__sub-section--collapsible
            { ambita-cadastre-report__sub-section--collapsed: collapseCulturalHeritages }"
    each="{ heritage in opts.heritages }">
    <div>
      <header class="ambita-cadastre-report__sub-section-header" onclick="{ collapse }">
        <i class="ambita-cadastre-report__sub-section-arrow"></i>
        <h5 class="ambita-report-h5">
          <span>{ heritage.localityNumber }</span> { heritage.categoryCode.text }
        </h5>
      </header>
      <div class="ambita-cadastre-report__sub-section-content">
        <div class="ambita-cadastre-report-clearfix">
          <ul class="ambita-cadastre-report__document-output ambita-report-ul">
            <li>
              <span class="ambita-cadastre-report__document-output-title">
                { i18n.propertyLookup.heritageType }
              </span>
              <span class="ambita-cadastre-report__document-output-value">
                { heritage.heritageType.text }
              </span>
            </li>
            <li>
              <span class="ambita-cadastre-report__document-output-title">
                { i18n.propertyLookup.heritagePreservationType }
              </span>
              <span class="ambita-cadastre-report__document-output-value">
                { heritage.preservationTypeCode.text }
              </span>
            </li>
            <li>
              <span class="ambita-cadastre-report__document-output-title">
                { i18n.propertyLookup.heritageCategory }
              </span>
              <span class="ambita-cadastre-report__document-output-value">
                { heritage.categoryCode.text }
              </span>
            </li>
            <li>
              <span class="ambita-cadastre-report__document-output-title">
                { i18n.propertyLookup.heritageRegistered }
              </span>
              <span class="ambita-cadastre-report__document-output-value">
                { heritage.registeredDate.ddmmyyyy }
              </span>
            </li>
            <li>
              <span class="ambita-cadastre-report__document-output-title">
                { i18n.propertyLookup.heritageUpdated }
              </span>
              <span class="ambita-cadastre-report__document-output-value">
                { heritage.lastUpdatedDate.ddmmyyyy }
              </span>
            </li>
            <li class="ambita-cadastre-report__single-heritages-link">
              <a class="ambita-report-link" href="{ heritage.links.singleHeritageWebpage.href }" target="_blank">
                { i18n.propertyLookup.goToHeritagesInfoPage }
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <script>
    import { init } from '../sectionController';

    init(this);

    this.on('update', function () {
      this.collapseCulturalHeritages = this.shouldCollapse(this.opts.heritages);
    });
  </script>
</ambita-cadastre-report-single-heritages>
